import styled from 'styled-components';
import { vars } from '../../theme';

export const ProgressBar = styled.div<{ height?: number }>`
    display: flex;
    gap: 2px;
    width: 100%;
    height: ${({ height }) => height + 'px'};
    border-radius: ${({ height }) => height / 2 + 'px'};
    background-color: ${vars.colors.surface.itemInset};
    overflow: hidden;
`;

export const BarSection = styled.div<{ color: string; percent: number }>`
    width: ${({ percent }) => percent}%;
    background-color: ${({ color }) => color};
`;
